import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/**
 *
 */
class Layout_three_flex  extends Layout_base {
  render() {
    return (
      <Col xs={12} className="generic__three-flex">
        {this.sectionHead()}
        <Row>
          <Col xs={12} sm={4}>{this.componentDOM(0)}</Col>
          <Col xs={12} sm={4}>{this.componentDOM(1)}</Col>
          <Col xs={12} sm={4}>{this.componentDOM(2)}</Col>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_three_flex;
